"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderLineImportStatus = void 0;
var SalesOrderLineImportStatus;
(function (SalesOrderLineImportStatus) {
    SalesOrderLineImportStatus["NOT_IMPORTED"] = "Not imported";
    SalesOrderLineImportStatus["NO_CHANGE"] = "No change";
    SalesOrderLineImportStatus["NEW"] = "New";
    SalesOrderLineImportStatus["UPDATED"] = "Updated";
    SalesOrderLineImportStatus["PRODUCT_NOT_FOUND"] = "Product not found";
    SalesOrderLineImportStatus["MISSING_REQUIRED_DATA_ERROR"] = "Missing required data";
    SalesOrderLineImportStatus["QUANTITY_IS_ZERO_ERROR"] = "Zero quantity";
    SalesOrderLineImportStatus["SERVER_PROCESSING_ERROR"] = "Server error";
})(SalesOrderLineImportStatus = exports.SalesOrderLineImportStatus || (exports.SalesOrderLineImportStatus = {}));
//# sourceMappingURL=sales-order-line-import-status.enum.js.map